/**
 * Created by Rhinov22e on 04/10/2016.
 *
 * OpeningNode joinery entity node (Ouverture)
 */

import { JoineryNode } from "../JoineryNode";
import { PlanManager } from "../../../../../cocosPlan";
import { Opening, SceneConstants } from "@rhinov/savane-js";

declare var cc: any;

export class OpeningNode extends JoineryNode {
    constructor(jOpening: Opening) {
        // Call super class constructor
        super(jOpening);
        // And prepare the node for display
        this.computeModel(jOpening);
    }

     // Prepare node for display
    computeModel(joinery: Opening) {
        // Retrieve joinery parameters if not undefined
        if (joinery !== undefined) {
            this._length = joinery.length;
            if (joinery.wall != null) {
                this._thickness = joinery.wall.thickness;
            }
            else {
                this._thickness = this._length / 10;
            }
        }

        /*        // New sprite
                var sprite = new cc.Sprite();
                // Sprite texture image name
                var spriteName = 'plan/opening.png';
                if (this._isSelected)
                {
                    spriteName = 'plan/openingSelected.png';
                }
                else
                {
                    if (this._isHovered)
                    {
                        spriteName = 'plan/openingHovered.png';
                    }
                }
                // Init sprite texture image
                sprite.initWithSpriteFrameName(spriteName);
                // Set anchoring
                sprite.setAnchorPoint(0.5, 0.5);
                // Set scale X and Y
                sprite.setScaleX(this._length / (sprite.width * 10));
                sprite.setScaleY(this._thickness === 0 ? 0.4 : this._thickness / (sprite.height * 10));
                sprite.setVisible(false);
                // And add the sprite to the rendering
                this.addChild(sprite);*/
    }

    // Draw manual rectangles for the node
    drawOverlap(joinery: Opening, isValid: boolean) {
        var alpha = 255;
        if (this.transparentDraw) {
            alpha = 64;
        }
        // Clear the node display
        this.clear();
        // If the node thickness > 0 (it would be invisible)
        if (this._thickness > 0) {
            // x, y, w, h of the element being displayed
            var h = (this._thickness * 0.1);
            var w = this._length * 0.1;
            var y = -h * 0.5;
            var x = -w * 0.5;
            // Color to use for the display
            var color: {border: any, plain:any} = {border: undefined, plain: undefined};
            // Border size
            var borderSize = 1;

            // Select color depending on valid/invalid, selected/unselected
            if (isValid != undefined) {
                color = this.getOverLapColor(isValid);
            }
            else {
                color = this.getOverLapColor(true);
            }

            if (borderSize * PlanManager.getInstance().getZoomScale() < 1) {
                borderSize /= PlanManager.getInstance().getZoomScale();
            }
            this.drawRect(new cc.p(x, y), new cc.p(x + w, y + h), color.plain, borderSize, color.border);

            if (this._joineryType === SceneConstants.JoineryType.garageDoor) {
                this.drawRect(new cc.p(-w * 0.02 - borderSize * 0.5, y - (h / 8) + borderSize * 0.5),
                    new cc.p(w * 0.02 + borderSize * 0.5, y + borderSize * 0.5),
                    new cc.Color(66, 80, 94, alpha), borderSize, new cc.Color(66, 80, 94, alpha));
            }
        }
    }

    update(dt: number) {
        super.update(dt);
    }

    // Update node model, prepare for next frame display
    updateModel(joinery: Opening, isValid: boolean) {
        // Empty current node display
        this.removeAllChildren();
        // Add prepare the content to display
        this.computeModel(joinery);
        // Call Joinery node update model method
        super.updateModel(joinery, isValid);
        // Draw node additionnal rects
        this.drawOverlap(joinery, isValid);
    }
}